import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Home } from "lucide-react";
import { useUiPack } from "@/hooks/useUiPack";
import { useLocale } from "@/contexts/LocaleProvider";
import "@/styles/simple-ui.css";

/** Simple pack chrome for admin settings pages. */
export default function SimpleAdminChrome({ children }) {
  const { isSimple } = useUiPack();
  const { t } = useTranslation();
  const { isRtl } = useLocale();
  const { pathname } = useLocation();

  if (!isSimple) return children;

  if (pathname === "/admin" || pathname === "/admin/") {
    return children;
  }

  return (
    <div className="simple-ui flex h-full min-h-0 flex-col" dir={isRtl ? "rtl" : "ltr"}>
      <div className="flex shrink-0 flex-wrap items-center gap-2 border-b border-violet-200 bg-violet-600 px-3 py-2 text-white print:hidden">
        <Link to="/" className="inline-flex h-10 items-center gap-1.5 rounded-xl bg-white/15 px-3 text-sm font-bold hover:bg-white/25">
          <Home className="h-4 w-4" />
          {t("common.home")}
        </Link>
        <Link to="/admin" className="inline-flex h-10 items-center gap-1.5 rounded-xl bg-white/15 px-3 text-sm font-bold hover:bg-white/25">
          <ArrowLeft className="h-4 w-4" />
          {t("nav.administration")}
        </Link>
      </div>
      <div className="min-h-0 flex-1 overflow-auto bg-[#EFE6DE]">
        {children}
      </div>
    </div>
  );
}
